import { Box } from '@mui/material';
import React from 'react';
import './style.scss';
import { useTenant } from '@context/TenantProvider';
import { ILoader } from './interfaces';

export const Loader: React.FC<ILoader> = ({
  sx,
  color,
  size = 'normal',
}): JSX.Element => {
  const tenant = useTenant();

  return (
    <Box display="flex" justifyContent="center" sx={sx}>
      <Box
        className={`loader loader-size-${size}`}
        sx={{
          background: `${color || tenant?.theme.colors?.primary || '#25b09b'} !important`,
        }}
      ></Box>
    </Box>
  );
};
